function isUndefined(variable) {
    return 'undefined' === typeof variable;
}

function isString(variable) {
    return 'string' === typeof variable;
}

function isBool(variable) {
    return 'boolean' === typeof variable;
}

function isNumber(variable) {
    return 'number' === typeof variable;
}

function isObject(variable) {
    return 'object' === typeof variable;
}

function isFn(variable) {
    return 'function' === typeof variable;
}

function isSymbol(variable) {
    return 'symbol' === typeof variable;
}

/**
 *
 * @param select a string like 'some.thing'
 * @param obj an object containing data like {some:{ thing: mixed }}
 * @return {any}
 */
function selectByDot(select, obj) {
    return select.split('.').reduce((o, i) => o[i], obj);
}

export {
    isUndefined, isBool, isString, isNumber, isObject, isFn, isSymbol,
    selectByDot
};